import { render } from "./Footer.vue?vue&type=template&id=a5a28d9a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=a5a28d9a&scoped=true&lang=css"

import exportComponent from "/home/vitsuji/Projects/iGEM-Wiki/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a28d9a"]])

export default __exports__